import React, { useEffect, useRef } from "react";
import ApiService from "../services/apiService";

interface EmailSenderProps {
  sid: number;
  phoneNumber: string;
  deviceMessage: string;
  onEmailSent: () => void;
}

const EmailSender: React.FC<EmailSenderProps> = ({
  sid,
  phoneNumber,
  deviceMessage,
  onEmailSent,
}) => {
  const sentRef = useRef(false); // prevent multiple sends
console.log(sid);
console.log(phoneNumber);
  useEffect(() => {
    const sendEmail = async () => {
      if (sentRef.current) return;

      try {
        console.log("Sending email:", { sid, phoneNumber, deviceMessage });

        const res = await ApiService.axiosApi("/Email/send", {
          method: "POST",
          data: {
            sid,
            mobileNumber: phoneNumber,
            subject: "Device Login Info",
            message: deviceMessage,
          },
        });

        if (res.success) {
          console.log("Email sent successfully!");
          sentRef.current = true;
          onEmailSent();
        } else {
          console.error("Failed to send email");
        }
      } catch (err) {
        console.error("Email send error:", err);
      }
    };

    sendEmail();
  }, [sid, phoneNumber, deviceMessage, onEmailSent]);

  return null; // no UI needed
};

export default EmailSender;